// Имя cookie — как в Django по умолчанию (`CSRF_COOKIE_NAME`). Её выдаёт `GET /api/me`.
const CSRF_COOKIE = "csrftoken";

// Токен CSRF для обычной HTML-формы (поле `csrfmiddlewaretoken`); `""`, если cookie ещё нет.
// Клиент API ставит заголовок сам (`shared/api/middleware/csrf.ts`), но вход через Steam —
// это не запрос API, а отправка формы с переходом на сайт Steam.
export const readCsrfToken = (): string => {
  const prefix = `${CSRF_COOKIE}=`;
  for (const part of document.cookie.split(";")) {
    const cookie = part.trim();
    if (cookie.startsWith(prefix)) {
      return decodeURIComponent(cookie.slice(prefix.length));
    }
  }
  return "";
};
